(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4713],{

/***/ 94082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layouts_GlobalLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./blocks/DialoguePresenter/DialoguePresenter.tsx
var DialoguePresenter = __webpack_require__(38114);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./components/NavigationItem/NavigationItem.tsx
var NavigationItem = __webpack_require__(10493);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsIcon.tsx
var LittleEmperorsIcon = __webpack_require__(21965);
// EXTERNAL MODULE: ./customHooks/useDialogue/useDialogue.ts
var useDialogue = __webpack_require__(82113);
// EXTERNAL MODULE: ./customHooks/useSignIn/useSignIn.ts
var useSignIn = __webpack_require__(37394);
// EXTERNAL MODULE: ./utils/memberAppSignInRedirect.ts
var memberAppSignInRedirect = __webpack_require__(37918);
// EXTERNAL MODULE: ./components/icons/BurgerMenuIcon.tsx
var BurgerMenuIcon = __webpack_require__(61063);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsTextIcon.tsx
var LittleEmperorsTextIcon = __webpack_require__(15096);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
;// CONCATENATED MODULE: ./components/icons/BurgerMenuCloseIcon.tsx

var BurgerMenuCloseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#A)",
                "fill-rule": "evenodd",
                fill: "#fff",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.497 3.493a.5.5 0 0 1 .707 0l16.305 16.305a.5.5 0 0 1-.707.707L3.497 4.2a.5.5 0 0 1 0-.707z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M20.502 3.491a.5.5 0 0 1 0 .707L4.198 20.503a.5.5 0 1 1-.707-.707L19.795 3.491a.5.5 0 0 1 .707 0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "A",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h24v24H0z"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var icons_BurgerMenuCloseIcon = (BurgerMenuCloseIcon);

// EXTERNAL MODULE: ./customHooks/useAuth/AuthProvider.tsx + 1 modules
var AuthProvider = __webpack_require__(52961);
;// CONCATENATED MODULE: ./blocks/Header/Header.tsx




















var Header = function() {
    var router = (0,next_router.useRouter)();
    var join_us_text = (0,useLocalised/* default */.Z)(translationKeys.join_us);
    var sign_in_text = (0,useLocalised/* default */.Z)(translationKeys.sign_in);
    var ref = (0,react.useContext)(useSignIn/* SignInContext */.f), setSignInState = ref.setState;
    var ref1 = (0,react.useContext)(useDialogue/* DialogueContext */.$), openDialogue = ref1.openDialogue, closeDialogue = ref1.closeDialogue, dialogueState = ref1.dialogueState;
    var isMobileMenuOpen = dialogueState.presentedDialogueType === constants/* MOBILE_MENU_DIALOGUE */.uN;
    var handleClickOnSignIn = (0,react.useCallback)(function() {
        var hotelRedirect = (0,memberAppSignInRedirect/* getHotelMemberSignInRedirectFromRouter */.e)(router.pathname, router.query);
        setSignInState(function(s) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                redirectTo: hotelRedirect
            });
        });
        openDialogue(constants/* SIGN_IN_DIALOG */.jt);
    }, [
        openDialogue,
        router.pathname,
        router.query,
        setSignInState
    ]);
    var handleClickOnJoinUs = (0,react.useCallback)(function() {
        openDialogue(constants/* JOIN_US_DIALOG_STEP_1 */.le);
    }, [
        openDialogue
    ]);
    var handleBurgerMenuClick = (0,react.useCallback)(function() {
        openDialogue(constants/* MOBILE_MENU_DIALOGUE */.uN);
    }, [
        openDialogue
    ]);
    var signedIn = (0,AuthProvider/* useAuth */.a)().signedIn;
    var homePage = signedIn ? constants/* navigationPaths.WEB_APP_HOMEPAGE */.aY.WEB_APP_HOMEPAGE : constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "header-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-component__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Hotels",
                            path: constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Membership",
                            path: constants/* navigationPaths.MEMBERSHIP */.aY.MEMBERSHIP,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Gift cards",
                            path: constants/* navigationPaths.E_GIFT_CARD */.aY.E_GIFT_CARD,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "MyLER",
                            path: constants/* navigationPaths.INDEPENDENT_TRAVEL_AGENT */.aY.INDEPENDENT_TRAVEL_AGENT,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: "Journal",
                            path: constants/* navigationPaths.TRAVEL_JOURNAL_ARTICLES */.aY.TRAVEL_JOURNAL_ARTICLES,
                            className: "header-navigation-item"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "burger-icon",
                    children: [
                        !isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: handleBurgerMenuClick,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerMenuIcon/* default */.Z, {})
                        }),
                        isMobileMenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            onClick: closeDialogue,
                            title: "mobile-menu",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_BurgerMenuCloseIcon, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homePage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: homePage,
                            className: "header-text-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsTextIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-rigth",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: join_us_text,
                            onClick: handleClickOnJoinUs,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-join_us_text_button"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            title: sign_in_text,
                            onClick: handleClickOnSignIn,
                            buttonType: Button/* LINK_BUTTON_TYPE */.II,
                            className: "header-navigation-item"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Header_Header = (Header);

// EXTERNAL MODULE: ./blocks/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(53114);
;// CONCATENATED MODULE: ./utils/header.ts
function formatCanonicalUrl(url) {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return url;
    }
    return url.replace(/^https?:\/\/(www\.)?/, "https://");
}
// gets first sentence or two from some copy
function getDescriptionFromContent(text) {
    if (!text) {
        return "";
    }
    var sentences = text.match(/[^.!?]+[.!?](?=\s+|$)/g);
    if (!sentences) {
        return text;
    }
    // help avoid splitting on common abbreviations  
    var abbreviations = /\b(?:[A-Z]\.|(?:[A-Z]\w{0,2}\.){2,}|e\.g\.|i\.e\.)/i;
    var combinedText = sentences[0].trim();
    // sensible minimum length for description
    if (combinedText.length > 90) {
        return combinedText;
    }
    for(var i = 1; i < sentences.length; i++){
        if (abbreviations.test(sentences[i])) {
            combinedText += " " + sentences[i].trim();
            continue;
        }
        combinedText += " " + sentences[i].trim();
        if (combinedText.length > 90) {
            return combinedText;
        }
    }
    return text;
}

;// CONCATENATED MODULE: ./blocks/Layouts/GlobalLayout.tsx



//Components



var GlobalLayout = function(param) {
    var children = param.children, memberships = param.memberships, currencies = param.currencies, countryCodes = param.countryCodes, metaData = param.metaData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Little Emperors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaData.url
                    }),
                    metaData.type && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: metaData.type
                    }),
                    metaData.image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaData.image
                    }),
                    metaData.author && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: metaData.author
                    }),
                    metaData.publishedTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:published_time",
                        content: metaData.publishedTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: formatCanonicalUrl(metaData.url)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-content-container",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialoguePresenter/* default */.Z, {
                memberships: memberships,
                currencies: currencies,
                countryCodes: countryCodes
            })
        ]
    });
};
/* harmony default export */ var Layouts_GlobalLayout = (GlobalLayout);


/***/ }),

/***/ 80264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ page_layout_PageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./blocks/Layouts/page-layout/additional-note/AdditionalNote.module.scss
var AdditionalNote_module = __webpack_require__(57366);
var AdditionalNote_module_default = /*#__PURE__*/__webpack_require__.n(AdditionalNote_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/html-viewer/HtmlViewer.tsx


var HtmlViewer = /*#__PURE__*/ react.memo(function(param) {
    var tmp = param.as, Element = tmp === void 0 ? "div" : tmp, content = param.content, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Element, {
        className: className,
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
});
/* harmony default export */ var html_viewer_HtmlViewer = (HtmlViewer);

;// CONCATENATED MODULE: ./components/html-viewer/index.ts


;// CONCATENATED MODULE: ./blocks/Layouts/page-layout/additional-note/AdditionalNote.tsx





var AdditionalNote = function(param) {
    var additionalNote = param.additionalNote, className = param.className;
    var ref = additionalNote || {}, title = ref.title, description = ref.description;
    if (!title && !description) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((AdditionalNote_module_default()).container, className),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                as: "h5",
                children: title
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(html_viewer_HtmlViewer, {
                content: description
            })
        ]
    });
};
/* harmony default export */ var additional_note_AdditionalNote = (AdditionalNote);

// EXTERNAL MODULE: ./blocks/Layouts/page-layout/PageLayout.module.scss
var PageLayout_module = __webpack_require__(77669);
var PageLayout_module_default = /*#__PURE__*/__webpack_require__.n(PageLayout_module);
;// CONCATENATED MODULE: ./blocks/Layouts/page-layout/PageLayout.tsx





var PageLayout = function(param) {
    var children = param.children, title = param.title, image = param.image, heading = param.heading, description = param.description, additionalNote = param.additionalNote;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: (PageLayout_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: (PageLayout_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (PageLayout_module_default()).wrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    color: "grey-dark",
                                    weight: "medium",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                                    as: "h1",
                                    className: (PageLayout_module_default()).title,
                                    children: heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    className: (PageLayout_module_default()).subtitle,
                                    children: description
                                })
                            ]
                        }),
                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PageLayout_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: image,
                                alt: "Header image for ".concat(title, " page"),
                                className: (PageLayout_module_default()).image,
                                layout: "fill",
                                priority: true
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (PageLayout_module_default()).content,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(additional_note_AdditionalNote, {
                additionalNote: additionalNote
            })
        ]
    });
};
/* harmony default export */ var page_layout_PageLayout = (PageLayout);

;// CONCATENATED MODULE: ./blocks/Layouts/page-layout/index.ts



/***/ }),

/***/ 26200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(966);
/* harmony import */ var _BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63057);
/* harmony import */ var components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95475);









var Button = function(_param) {
    var children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "primary-gold" : _variant, _size = _param.size, size = _size === void 0 ? "large" : _size, isLoading = _param.isLoading, className = _param.className, onClick = _param.onClick, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "variant",
        "size",
        "isLoading",
        "className",
        "onClick"
    ]);
    var cn = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6___default()["default"]), (_BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6___default())[variant], (_BaseButton_module_css__WEBPACK_IMPORTED_MODULE_6___default())[size], className);
    var handleClick = isLoading ? undefined : onClick;
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .getMarginFromProps */ .X)(rest);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        className: cn,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, marginStyle),
        onClick: handleClick,
        disabled: isLoading
    }, rest), {
        children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 41107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HB": function() { return /* binding */ FILLED_BUTTON_TYPE_DARK; },
/* harmony export */   "II": function() { return /* binding */ LINK_BUTTON_TYPE; },
/* harmony export */   "ME": function() { return /* binding */ FILLED_BUTTON_TYPE; },
/* harmony export */   "Wr": function() { return /* binding */ OUTLINED_BUTTON_TYPE_DARK; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95475);



var LINK_BUTTON_TYPE = "LINK_BUTTON_TYPE";
var FILLED_BUTTON_TYPE = "FILLED_BUTTON_TYPE";
var FILLED_BUTTON_TYPE_DARK = "FILLED_BUTTON_TYPE_DARK";
var OUTLINED_BUTTON_TYPE_DARK = "OUTLINED_BUTTON_TYPE_DARK";
var Button = function(param) {
    var title = param.title, onClick = param.onClick, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? FILLED_BUTTON_TYPE : _buttonType, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, className = param.className, htmlAttributes = param.htmlAttributes;
    var handleOnClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (isLoading) {
            return;
        }
        onClick();
    }, [
        isLoading,
        onClick
    ]);
    var getClass = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var classNameArray = [];
        var inititalClassName = "button-body-filled";
        switch(buttonType){
            case LINK_BUTTON_TYPE:
                inititalClassName = "button-body-link";
                break;
            case FILLED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-filled-dark";
                break;
            case OUTLINED_BUTTON_TYPE_DARK:
                inititalClassName = "button-body-outlined-dark";
            default:
                break;
        }
        classNameArray.push(inititalClassName);
        if (className) {
            classNameArray.push(className);
        }
        return classNameArray.join(" ");
    }, [
        buttonType,
        className
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.type,
        onClick: handleOnClick,
        className: getClass(),
        "area-label": title,
        style: htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.style,
        disabled: (htmlAttributes === null || htmlAttributes === void 0 ? void 0 : htmlAttributes.disabled) || false,
        children: [
            !isLoading && title,
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Spinner_Spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Button);


/***/ }),

/***/ 98736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ accordion_list_AccordionList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js
var Accordion = __webpack_require__(86532);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(63083);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(61250);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(16003);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Button/BaseButton.tsx
var BaseButton = __webpack_require__(26200);
;// CONCATENATED MODULE: ./blocks/CareerListSection/icons/RightArrow.tsx

var RightArrowIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.5 5H8.5M8.5 5L5 1.5M8.5 5L5 8.5",
            stroke: "#475467",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var RightArrow = (RightArrowIcon);

;// CONCATENATED MODULE: ./blocks/CareerListSection/icons/CloseIcon.tsx

var CloseIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 8 8",
        width: "8",
        height: "8",
        fill: "none",
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7 1L1 7M1 1L7 7",
            stroke: "#505050",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var icons_CloseIcon = (CloseIcon);

// EXTERNAL MODULE: ./blocks/CareerListSection/components/expand-button/ExpandButton.module.scss
var ExpandButton_module = __webpack_require__(74620);
var ExpandButton_module_default = /*#__PURE__*/__webpack_require__.n(ExpandButton_module);
;// CONCATENATED MODULE: ./blocks/CareerListSection/components/expand-button/ExpandButton.tsx








var ExpandButton = function(param) {
    var _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _withLabel = param.withLabel, withLabel = _withLabel === void 0 ? true : _withLabel;
    if (expanded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseButton/* default */.Z, {
            className: (ExpandButton_module_default()).closeButton,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_CloseIcon, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseButton/* default */.Z, {
        className: classnames_default()((ExpandButton_module_default()).expandButton, (0,_define_property/* default */.Z)({}, (ExpandButton_module_default()).circleIcon, !withLabel)),
        children: [
            withLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Small */.x4, {
                children: "View details"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow, {})
        ]
    });
};
/* harmony default export */ var expand_button_ExpandButton = (ExpandButton);

;// CONCATENATED MODULE: ./blocks/CareerListSection/components/expand-button/index.ts


;// CONCATENATED MODULE: ./components/accordion-list/AccordionList.tsx








var AccordionList = function(param) {
    var items = param.items, renderContent = param.renderContent, getId = param.getId, getTitle = param.getTitle, getContent = param.getContent, _getChipLabel = param.getChipLabel, getChipLabel = _getChipLabel === void 0 ? function() {
        return "";
    } : _getChipLabel, _withLabel = param.withLabel, withLabel = _withLabel === void 0 ? false : _withLabel;
    var ref = (0,react.useState)(null), expandedPanelId = ref[0], setExpandedPanelId = ref[1];
    var handleAccordionChange = (0,react.useCallback)(function(id) {
        return function() {
            setExpandedPanelId(function(prevId) {
                return prevId === id ? null : id;
            });
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "accordion-list-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "accordion-list",
            children: items.map(function(item) {
                var id = getId(item);
                var title = getTitle(item);
                var content = getContent(item);
                var showText = typeof content === "string" && content.length > 0;
                var chipLabel = getChipLabel(item);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                    disableGutters: true,
                    elevation: 0,
                    className: "accordion-accordion",
                    expanded: expandedPanelId === id,
                    onChange: handleAccordionChange(id),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionSummary/* default */.Z, {
                            "aria-controls": id,
                            id: id,
                            className: "accordion-accordion__summary",
                            expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(expand_button_ExpandButton, {
                                expanded: expandedPanelId === id,
                                withLabel: withLabel
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    fontSize: 18,
                                    color: "gold-dark",
                                    className: "accordion-accordion__title",
                                    children: title
                                }),
                                chipLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                    label: chipLabel,
                                    size: "small",
                                    className: "role-tag"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "accordion-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "accordion-container__left",
                                    children: [
                                        !showText && (renderContent === null || renderContent === void 0 ? void 0 : renderContent(item)),
                                        showText && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                            color: "grey-dark",
                                            children: content
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }, id);
            })
        })
    });
};
/* harmony default export */ var accordion_list_AccordionList = (AccordionList);

;// CONCATENATED MODULE: ./components/accordion-list/index.ts



/***/ }),

/***/ 2466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BaseText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13394);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63057);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4093);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var BaseText = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, children = _param.children, _color = _param.color, color = _color === void 0 ? "black" : _color, weight = _param.weight, fontStyle = _param.fontStyle, letterSpacing = _param.letterSpacing, fontSize = _param.fontSize, align = _param.align, style = _param.style, isLink = _param.isLink, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "as",
        "children",
        "color",
        "weight",
        "fontStyle",
        "letterSpacing",
        "fontSize",
        "align",
        "style",
        "isLink",
        "className"
    ]);
    var colorStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getColorFromString */ .T)(color);
    var fontWeightStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getFontWeightFromString */ .J)(weight);
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .getMarginFromProps */ .X)(rest);
    var joinedClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()((_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().baseText), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link), isLink), className);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: joinedClassName,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            fontWeight: fontWeightStyle,
            fontStyle: fontStyle,
            color: colorStyle,
            textAlign: align,
            letterSpacing: letterSpacing,
            fontSize: fontSize
        }, marginStyle, style)
    }, rest), children);
};


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);




var Body = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Body);


/***/ }),

/***/ 36443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85392);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Heading = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "h1" : _as, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        as: as,
        className: (_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[as]
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 82096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26926);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Small_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var Small = function(_param) {
    var _xs = _param.xs, xs = _xs === void 0 ? false : _xs, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "xs"
    ]);
    var joinedClassNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().xs), xs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        as: "small",
        className: joinedClassNames
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Small);


/***/ }),

/***/ 22538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* reexport safe */ _Heading__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "uT": function() { return /* reexport safe */ _Body__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "x4": function() { return /* reexport safe */ _Small__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _Body__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7117);
/* harmony import */ var _Small__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82096);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36443);





/***/ }),

/***/ 13394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ getColorFromString; },
  "J": function() { return /* binding */ getFontWeightFromString; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/shared/constants.ts
var constants = __webpack_require__(55774);
;// CONCATENATED MODULE: ./components/text/constants.ts
var weights = {
    regular: 400,
    medium: 500,
    demiBold: 600
};

;// CONCATENATED MODULE: ./components/text/utils.ts



var getColorFromString = function(colorString) {
    var ref = (0,_sliced_to_array/* default */.Z)(colorString.split("-"), 2), colorName = ref[0], shade = ref[1];
    var color = shade ? constants/* colors */.O[colorName][shade] : constants/* colors */.O[colorString];
    return color ? color : constants/* colors.black */.O.black;
};
var getFontWeightFromString = function(weightString) {
    if (!weightString) {
        return null;
    }
    var weight = weights[weightString];
    return weight ? weight : weights.regular;
};


/***/ }),

/***/ 37918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getHotelMemberSignInRedirectFromRouter; }
/* harmony export */ });
/**
 * When the user opens sign-in from a public hotel page, the member webapp expects
 * external-login?redirect=hotel/{numericId} (path after /ile/, no leading slash).
 */ function getHotelMemberSignInRedirectFromRouter(pathname, query) {
    if (pathname !== "/our-hotels/[idHotel]") {
        return undefined;
    }
    var raw = query.idHotel;
    var id = Array.isArray(raw) ? raw[0] : raw;
    if (typeof id !== "string" || !/^\d+$/.test(id)) {
        return undefined;
    }
    return "hotel/".concat(id);
}


/***/ }),

/***/ 966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"default":"BaseButton_default__OOxIm","primary-gold":"BaseButton_primary-gold__nlw99","primary-black":"BaseButton_primary-black__4obai","secondary-dark-grey":"BaseButton_secondary-dark-grey__1uTe2","secondary-white":"BaseButton_secondary-white__8gmRG","secondary-ghost":"BaseButton_secondary-ghost__QLilf","full":"BaseButton_full__ctUcM","large":"BaseButton_large__EBpgm","medium":"BaseButton_medium__sfmQ1","small":"BaseButton_small__Ou0rI","xs":"BaseButton_xs__VALNV"};

/***/ }),

/***/ 74620:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"expandButton":"ExpandButton_expandButton__rsrTY","closeButton":"ExpandButton_closeButton__x9aG4","circleIcon":"ExpandButton_circleIcon__p466Q"};

/***/ }),

/***/ 77669:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLayout_container__6G5D5","header":"PageLayout_header__ASkvF","wrapper":"PageLayout_wrapper__XsyyL","title":"PageLayout_title__kxaL3","subtitle":"PageLayout_subtitle__qfdRt","content":"PageLayout_content__PWx2_","imageWrapper":"PageLayout_imageWrapper__mMJRv","image":"PageLayout_image__wdXuU"};

/***/ }),

/***/ 57366:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"AdditionalNote_container__W2gN_"};

/***/ }),

/***/ 4093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseText":"BaseText_baseText__UdRof","link":"BaseText_link__iIUwY"};

/***/ }),

/***/ 85392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__JrX4F","h2":"Heading_h2__meWYJ","h3":"Heading_h3__7RMCn","h4":"Heading_h4__IrnJ5","h5":"Heading_h5__pT9p1"};

/***/ }),

/***/ 26926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small":"Small_small__B42wk","xs":"Small_xs__SqaGj"};

/***/ })

}]);